// extracted by mini-css-extract-plugin
export default {"container":"NoNotification_container__FWZDL"};